/** @format */

import { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  GA4_COMPONENT_NAME,
  GA4_COMPONENT_TYPE,
  resolveBackButtonGa4Position
} from 'src/analytics/componentInteractionGa4';
import useGa4Analytics from 'src/hooks/useGa4Analytics';
import { Button } from '.';

const Backbtn = props => {
  const { kb, isNews, componentPosition } = props;
  const { t } = useTranslation();
  const { trackComponentInteraction } = useGa4Analytics();
  const location = useLocation();
  const requestedBackTo = (location.state as { backTo?: unknown } | null)?.backTo;
  const returnPath =
    typeof requestedBackTo === 'string' && requestedBackTo.startsWith('/') && !requestedBackTo.startsWith('//')
      ? requestedBackTo
      : null;
  const backLink = returnPath ?? (kb ? `/knowledge-base/${kb}` : isNews ? `/news` : '/');
  const backLabel = kb
    ? t('backToAllArticlesBtn')
    : isNews
      ? t('common.button.backToNewsBtn')
      : t('common.button.backbtn');

  const handleClick = useCallback(() => {
    trackComponentInteraction({
      component_name: GA4_COMPONENT_NAME.BACK_BUTTON,
      component_type: GA4_COMPONENT_TYPE.BUTTON,
      component_position: resolveBackButtonGa4Position({ kb, isNews, componentPosition })
    });
  }, [componentPosition, isNews, kb, trackComponentInteraction]);

  return (
    <>
      <div className="btn-container" style={{ viewTransitionName: 'back-btn' }}>
        <Link to={backLink}>
          <Button borderOnly back label={backLabel} onClick={handleClick} />
        </Link>
      </div>
    </>
  );
};

export { Backbtn };
